import Axios from 'axios'
import requestPrefix from '../requestPrefix'

export default {

  // 项目树状结构
  projectDeptlist(projectId) {
    return Axios({
      url: requestPrefix.projectUrl + '/projectDept/deptTree/' + projectId,
      method: 'get'
    })
  },
  // 保存
  mobileReportBillSave(data) {
    return Axios({
      url: requestPrefix.projectUrl + '/reportBill/save',
      method: 'post',
      data: data
    })
  },
  // 更新检查单
  mobileReportRectifyUpdate(data) {
    return Axios({
      url: requestPrefix.projectUrl + '/reportBillRectify/update',
      method: 'post',
      data: data
    })
  },
  // 详情
  mobileReportBillgetById(data) {
    return Axios({
      url: requestPrefix.projectUrl + '/reportBill/getById',
      method: 'get',
      params: data
    })
  },

    mobileReportBillgetById2(data) {
        return Axios({
            url: requestPrefix.projectUrl + '/reportBill/getById',
            method: 'get',
            params: data
        })
    },
    mobileReportBillgetById3(data) {
        return Axios({
            url: requestPrefix.projectUrl + '/reportBill/getByBillId',
            method: 'get',
            params: data
        })
    },

  // 删除
  // mobilesourceCheckremove(id) {
  //   return Axios({
  //     url: requestPrefix.projectUrl + '/reportBill/remove/' + id,
  //     method: 'get'
  //   })
  // },

  // 全部问题
  mobileReportBillPageAll(params) {
    return Axios({
      url: requestPrefix.projectUrl + '/reportBill/pageAll',
      method: 'get',
      params: params
    })
  },
  // 各个项目本月安全隐患新增
  reportBillCountAllCheck(params) {
    return Axios({
      url: requestPrefix.projectUrl + '/reportBill/countAllCheck',
      method: 'get',
      params: params
    })
  }
  // 分配处理人
  // mobileanyPhotopageAllocate(params) {
  //   return Axios({
  //     url: requestPrefix.projectUrl + '/reportBill/pageAllocate',
  //     method: 'get',
  //     params: params
  //   })
  // },

}



// WEBPACK FOOTER //
// ./src/api/reportbill/index.js